<template>
  <!-- display: block -->
  <v-card outlined color="transparent">
    <v-form ref="cform" @submit.prevent="submit">
      <v-card-title>Kontaktformulär</v-card-title>
      <!-- display: block -->
      <v-row>
        <v-col cols="6">
          <v-card-text>
            <!-- display: block -->
            <!-- display: block -->
            <v-text-field solo v-model="name" label="Namn" color="primary">
              <!-- display: block -->
              <template v-slot:prepend-inner>
                <v-icon color="secondary">mdi-account</v-icon>
              </template>
            </v-text-field>

            <!-- display: block -->
            <v-text-field solo v-model="phone" label="Telefonnummer" :rules="phoneRules">
              <!-- display: block -->
              <template v-slot:prepend-inner>
                <v-icon color="secondary">mdi-phone</v-icon>
              </template>
            </v-text-field>

            <!-- display: block -->
            <v-text-field solo v-model="email" label="E-mail" :rules="emailRules">
              <!-- display: block -->
              <template v-slot:prepend-inner>
                <v-icon color="secondary">mdi-email</v-icon>
              </template>
            </v-text-field>
          </v-card-text></v-col
        >

        <!-- display: block -->
        <v-col cols="6">
          <!-- display: block -->
          <v-card-text>
            <v-textarea solo v-model="message" label="Meddelande" rows="7">
              <!-- display: block -->
              <template v-slot:prepend-inner>
                <v-icon color="secondary">mdi-message-text</v-icon>
              </template>
            </v-textarea>
          </v-card-text>
        </v-col>
      </v-row>
      <v-card-actions>
        <v-btn class="mt-2" color="secondary" :disabled="!hasContactDetails" block>Skicka</v-btn>
      </v-card-actions>
    </v-form>
  </v-card>
</template>

<script>
export default {
  data: () => ({
    name: '',
    phone: '',
    phoneRules: [(v) => !v || /^\s*[+0][0-9 ]*$/.test(v) || 'Ogiltigt telefonnummer'],
    email: '',
    emailRules: [(v) => !v || /.+@.+\..+/.test(v) || 'Ogiltig e-postadress'],
    message: ''
  }),
  computed: {
    hasContactDetails() {
      return this.phone || (this.email && this.$refs.cform.validate())
    }
  },
  methods: {
    submit() {
      console.log('SUBMIT')
    }
  }
}
</script>
